import { InvoiceTaxModel } from '../../invoice/preinvoice/invoicetax.model';

export class SerialNumberModel {
  id: number;
  serialNumber: string;
  invoiceUid: string;
  invoiceNumber: string;

  constructor() {
    this.id = 0;
  }
}

export class ConceptModel {
  uid: string;
  categoryUid: string;
  categoryName: string;
  name: string;
  description: string;
  shortcut: string;
  price: number;
  discount: number;
  netPrice: number;
  costPrice: number;
  codigoStock: string;
  units: number;
  limitUnits: number;
  isStockEnabled: boolean;
  barcode: string;
  serialNumber: boolean;
  size: string;
  model: string;

  fileId: number;
  imageId: number;
  isTpv: boolean;


  taxes: Array<InvoiceTaxModel>;

  constructor() {
    this.taxes = new Array<InvoiceTaxModel>();
    this.categoryName = '';
    this.isStockEnabled = false;
    this.serialNumber = false;
    this.costPrice = 0;
    this.discount = 0;
    this.netPrice = 0;
    this.fileId = 0;
    this.imageId = 0;
  }

}

export class ProviderConceptModel {
  id: number;
  providerUid: string;
  conceptUid: string;
}
